import React, { useState } from 'react';
import CustomInput from 'components/Additional/CustomInput/CustomInput';

import styles from './ManualAddressForm.module.css';

const ManualAddressForm = ({ formData, onChange, latlong }) => {
	const [errors, setErrors] = useState({});

	return (
		<div className={styles.container}>
			<CustomInput
				inputName="addr1"
				inputLabel="Address"
				value={formData.addr1}
				onChange={onChange}
			/>
			<div className={styles.container_row}>
				<CustomInput
					inputName="city"
					inputLabel="City"
					value={formData.city}
					onChange={onChange}
				/>
				<CustomInput
					inputName="state"
					inputLabel="State"
					value={formData.state}
					onChange={onChange}
					isDisabled
				/>
				<CustomInput
					inputName="postalCode"
					inputLabel="Postal Code"
					value={formData.postalCode}
					onChange={onChange}
					onInput={(e) => {
						e.target.value = e.target.value.replace(/\D/g, '');
						if (e.target.value.length > 5) {
							e.target.value = e.target.value.slice(0, 4);
						}
					}}
				/>
			</div>
			{latlong && (
				<span className={styles.latlong_text}>
					We are having a hard time finding your address please enter:
				</span>
			)}
			{latlong && (
				<div className={styles.container_row}>
					<CustomInput
						inputName="latitude"
						inputLabel="Latitude"
						value={formData.latitude}
						onChange={onChange}
					/>
					<CustomInput
						inputName="longtitude"
						inputLabel="Longtitude"
						value={formData.longtitude}
						onChange={onChange}
					/>
					<div style={{ visibility: 'hidden' }}>
						<CustomInput inputName="hidden" inputLabel="" />
					</div>
				</div>
			)}
		</div>
	);
};

export default ManualAddressForm;
